import styled from 'styled-components';
import {mobileMedia, scrollbar} from '../../../globalVariables/GlobalVariables';
import {icon} from '../../../component/classes/input';

export const wrapper = styled.div`
    padding-inline:50px;
    padding-top:20px;
    ${scrollbar};
    border-bottom: 1px solid #F3F3F3;
    ${icon}{
      display: none;
    }
`;

export const saveButton=styled.div`
    padding: 20px;
    direction: ltr;
`;

export const wrapList=styled.div`
    display: flex;
    padding-top: 10px;
    padding-bottom: 15px;
    ${mobileMedia}{
        display: block;
    }
`;

export const hubNotice = styled.div`
    margin: 10px 0 15px;
    padding: 12px 16px;
    border-radius: 8px;
    background: #f5f8ff;
    color: #333;
    font-size: 14px;
    line-height: 1.5;
`;